





















































































































































































































































































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
    name: 'Admin',
    data() {
        return {
            viewMode: 'accounts',
            runningCheck: false,
            accounts: [] as any[],
            activeTab: 'paid',
            searchQuery: '',
            tierFilter: 'all',
            editingAccount: null as any,
            showStripeSearch: false,
            stripeSearchEmail: '',
            stripeSearchLoading: false,
            stripeSearchDone: false,
            stripeSearchError: '',
            stripeSearchResults: [] as any[],
            users: [] as any[],
            userSearchQuery: '',
            editingUser: null as any,
            addAccountPortalId: '',
            addAccountRole: 'GeneralUser',
            inviteModalOpen: false,
            inviteEmail: '',
            inviteSystemRole: 'User',
            inviteError: '',
            billingLog: [] as any[],
            billingLogPortalFilter: '',
            pdfErrorLog: [] as any[],
            pdfErrorPortalFilter: '',
            pdfErrorSearchQuery: ''
        }
    },
    created() {
        if(this.$store.state.isSystemAdmin) {
            this.loadAccounts();
        } else {
            this.$router.push('/login');
        }
        this.$store.state.routeLoaded = true;
    },
    computed: {
        filteredAccounts(): any[] {
            return this.accounts.filter((account: any) => {
                const isPaid = !!account.HasPaid;
                if(this.activeTab === 'paid' && !isPaid) return false;
                if(this.activeTab === 'unpaid' && isPaid) return false;
                if(this.tierFilter !== 'all' && String(account.SubscriptionTier) !== this.tierFilter) return false;
                if(this.searchQuery) {
                    const q = this.searchQuery.toLowerCase();
                    const idMatch = String(account.HSPortalId).toLowerCase().includes(q);
                    const emailMatch = (account.Email || '').toLowerCase().includes(q);
                    if(!idMatch && !emailMatch) return false;
                }
                return true;
            });
        },
        filteredUsers(): any[] {
            if(!this.userSearchQuery) return this.users;
            const q = this.userSearchQuery.toLowerCase();
            return this.users.filter((user: any) => (user.Email || '').toLowerCase().includes(q));
        },
        filteredBillingLog(): any[] {
            if(!this.billingLogPortalFilter) return this.billingLog;
            const q = this.billingLogPortalFilter.toLowerCase();
            return this.billingLog.filter((entry: any) => String(entry.HSPortalId || '').toLowerCase().includes(q));
        },
        filteredPdfErrorLog(): any[] {
            return this.pdfErrorLog.filter((entry: any) => {
                if(this.pdfErrorPortalFilter && !String(entry.HSPortalId || '').toLowerCase().includes(this.pdfErrorPortalFilter.toLowerCase())) return false;
                if(this.pdfErrorSearchQuery) {
                    const q = this.pdfErrorSearchQuery.toLowerCase();
                    const haystack = [entry.Feature, entry.Code, entry.Template, entry.Message].map(v => (v || '').toLowerCase());
                    if(!haystack.some(v => v.includes(q))) return false;
                }
                return true;
            });
        }
    },
    methods: {
        loadAccounts() {
            axios.get(this.$store.state.apiUrl + '/admin/accounts')
                .then(resp => {
                    this.accounts = resp.data;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        loadUsers() {
            axios.get(this.$store.state.apiUrl + '/admin/users')
                .then(resp => {
                    this.users = resp.data;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        toggleTestMode(account: any, enabled: boolean) {
            axios.post(this.$store.state.apiUrl + '/admin/accounts/' + account.HSPortalId + '/test-mode', { enabled })
                .then(() => {
                    account.AlwaysActive = enabled;
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                });
        },
        openAccountModal(account: any) {
            // Clone so cancelling the modal doesn't leave half-edited values
            // sitting in the table's row object.
            this.editingAccount = { ...account };
            this.showStripeSearch = false;
            this.stripeSearchEmail = account.Email || '';
            this.stripeSearchDone = false;
            this.stripeSearchError = '';
            this.stripeSearchResults = [];
        },
        closeAccountModal() {
            this.editingAccount = null;
        },
        searchStripe() {
            if(!this.stripeSearchEmail || this.stripeSearchLoading) return;
            this.stripeSearchLoading = true;
            this.stripeSearchError = '';
            this.stripeSearchDone = false;
            axios.get(this.$store.state.apiUrl + '/admin/accounts/' + this.editingAccount.HSPortalId + '/stripe-search', {
                params: { email: this.stripeSearchEmail }
            })
                .then(resp => {
                    this.stripeSearchResults = resp.data;
                    this.stripeSearchDone = true;
                    this.stripeSearchLoading = false;
                })
                .catch(e => {
                    this.stripeSearchError = e.response ? e.response.data : 'There was an error searching Stripe.';
                    this.stripeSearchLoading = false;
                });
        },
        connectSubscription(match: any) {
            const acc = this.editingAccount;
            axios.post(this.$store.state.apiUrl + '/admin/accounts/' + acc.HSPortalId + '/link-subscription', {
                subscriptionId: match.subscriptionId,
                env: match.env
            })
                .then(resp => {
                    const updates = {
                        SubscriptionId: resp.data.subscriptionId,
                        SubscriptionEnv: resp.data.subscriptionEnv,
                        SubscriptionTier: resp.data.subscriptionTier,
                        HasPaid: resp.data.hasPaid
                    };
                    Object.assign(this.editingAccount, updates);
                    const idx = this.accounts.findIndex((a: any) => a.HSPortalId === acc.HSPortalId);
                    if(idx !== -1) {
                        this.accounts.splice(idx, 1, { ...this.accounts[idx], ...updates });
                    }
                    this.showStripeSearch = false;
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error connecting that subscription.');
                });
        },
        saveAccountEdits() {
            const acc = this.editingAccount;
            axios.put(this.$store.state.apiUrl + '/admin/accounts/' + acc.HSPortalId, {
                email: acc.Email,
                subscriptionTier: acc.SubscriptionTier,
                hasPaid: acc.HasPaid
            })
                .then(() => {
                    const idx = this.accounts.findIndex((a: any) => a.HSPortalId === acc.HSPortalId);
                    if(idx !== -1) {
                        this.accounts.splice(idx, 1, { ...this.accounts[idx], Email: acc.Email, SubscriptionTier: acc.SubscriptionTier, HasPaid: acc.HasPaid });
                    }
                    this.editingAccount = null;
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                });
        },
        formatDate(date: any): string | null {
            if(!date) return null;
            return new Date(date).toLocaleString();
        },
        trialEndDate(account: any): Date | null {
            if(!account.InstallTime) return null;
            return new Date(new Date(account.InstallTime).getTime() + 7 * 24 * 3600000);
        },
        isOnTrial(account: any): boolean {
            const end = this.trialEndDate(account);
            return !!end && end.getTime() > Date.now();
        },
        stripeSubscriptionUrl(account: any) {
            const base = account.SubscriptionEnv === 'test' ? 'https://dashboard.stripe.com/test/subscriptions/' : 'https://dashboard.stripe.com/subscriptions/';
            return base + account.SubscriptionId;
        },
        viewAs(portalId: string) {
            axios.post(this.$store.state.apiUrl + '/admin/view-as', { portalId })
                .then(() => {
                    window.location.href = '/';
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                });
        },
        accountLabel(portalId: any): string {
            const acc = this.accounts.find((a: any) => String(a.HSPortalId) === String(portalId));
            return acc ? `${acc.Email} (${portalId})` : String(portalId);
        },
        openInviteModal() {
            this.inviteEmail = '';
            this.inviteSystemRole = 'User';
            this.inviteError = '';
            this.inviteModalOpen = true;
        },
        sendInvite() {
            this.inviteError = '';
            axios.post(this.$store.state.apiUrl + '/admin/users', {
                email: this.inviteEmail,
                systemRole: this.inviteSystemRole
            })
                .then(() => {
                    this.inviteModalOpen = false;
                    this.loadUsers();
                })
                .catch(e => {
                    this.inviteError = e.response ? e.response.data : 'There was an error sending that invite.';
                });
        },
        openUserModal(user: any) {
            this.editingUser = { ...user, Accounts: user.Accounts.map((a: any) => ({ ...a })) };
            this.addAccountPortalId = '';
            this.addAccountRole = 'GeneralUser';
        },
        saveUserEdits() {
            const user = this.editingUser;
            axios.put(this.$store.state.apiUrl + '/admin/users/' + user.UserId, {
                email: user.Email,
                systemRole: user.SystemRole
            })
                .then(() => {
                    this.editingUser = null;
                    this.loadUsers();
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                });
        },
        updateUserAccountRole(acc: any, accountRole: string) {
            axios.post(this.$store.state.apiUrl + '/admin/users/' + this.editingUser.UserId + '/accounts', {
                portalId: acc.HSPortalId,
                accountRole
            })
                .then(() => {
                    acc.AccountRole = accountRole;
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                });
        },
        addUserAccount() {
            if(!this.addAccountPortalId) return;
            axios.post(this.$store.state.apiUrl + '/admin/users/' + this.editingUser.UserId + '/accounts', {
                portalId: this.addAccountPortalId,
                accountRole: this.addAccountRole
            })
                .then(() => {
                    this.editingUser.Accounts.push({ HSPortalId: this.addAccountPortalId, AccountRole: this.addAccountRole });
                    this.addAccountPortalId = '';
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                });
        },
        removeUserAccount(portalId: any) {
            axios.delete(this.$store.state.apiUrl + '/admin/users/' + this.editingUser.UserId + '/accounts/' + portalId)
                .then(() => {
                    this.editingUser.Accounts = this.editingUser.Accounts.filter((a: any) => String(a.HSPortalId) !== String(portalId));
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                });
        },
        logout() {
            axios.get(this.$store.state.apiUrl + '/signout')
                .then(() => {
                    this.$store.state.isSystemAdmin = false;
                    window.location.href = '/login';
                });
        },
        runSubscriptionCheck() {
            if(this.runningCheck) return;
            this.runningCheck = true;
            axios.post(this.$store.state.apiUrl + '/admin/run-subscription-check')
                .then(() => {
                    alert('Done - check the Billing Log tab for the output.');
                    this.runningCheck = false;
                    if(this.viewMode === 'billinglog') this.loadBillingLog();
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                    this.runningCheck = false;
                });
        },
        loadBillingLog() {
            axios.get(this.$store.state.apiUrl + '/admin/billing-log')
                .then(resp => {
                    this.billingLog = resp.data;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        formatBillingLogDate(dateStr: string): string {
            return new Date(dateStr).toLocaleString();
        },
        loadPdfErrorLog() {
            axios.get(this.$store.state.apiUrl + '/admin/pdf-error-log')
                .then(resp => {
                    this.pdfErrorLog = resp.data;
                })
                .catch(e => {
                    console.log(e);
                });
        }
    }
})
